import { ErrorState, Flex, type ErrorStateProps } from '@/components/common';
import { AppShell } from '@/components/layout';

export function ErrorPage({ title, message, action }: ErrorStateProps) {
  return (
    <AppShell>
      <Flex align="center" justify="center" className="flex-1">
        <ErrorState title={title} message={message} action={action} />
      </Flex>
    </AppShell>
  );
}
